module.exports = __webpack_public_path__ + "img/heatmap-dark-01.21f7e2b9.jpg";